import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

export const INITIAL_SCORE = 600;
const UPDATE_SCENARIO = '@@social-credit/UPDATE_SCENARIO';
const UPDATE_CHAPTER = '@@social-credit/UPDATE_CHAPTER';
const RESET_STATE = '@@social-credit/RESET_STATE';

export const updateScenario = ({ id, choice, score }) => ({
  type: UPDATE_SCENARIO,
  payload: { id, score, choice },
});

export const resetState = () => ({
  type: RESET_STATE,
});

export const updateChapter = title => ({
  type: UPDATE_CHAPTER,
  payload: {
    title,
  },
});

export const chapterSelector = state => ({
  currentChapter: state.currentChapter,
});

export const scoreCalculator = state => Object
  .values(state.scenarios)
  .reduce((prev, next) => prev + next.score, INITIAL_SCORE);

export const scoreSelector = state => ({
  score: scoreCalculator(state),
});

export const scenariosCompletedCount = state => Object.keys(state.scenarios).length;
export const scenarioSelector = id => state => state.scenarios[id];
export const choiceSelector = id => state => (scenarioSelector(id)(state) || {}).choice;

export const scoreUntilScenarioSelector = count => state => Object
  .values(state.scenarios)
  .slice(0, count)
  .reduce((prev, next) => prev + next.score, INITIAL_SCORE);

export const stateSelector = state => ({
  score: scoreCalculator(state),
  currentChapter: state.currentChapter,
});

const initialState = {
  currentChapter: '',
  scenarios: {},
};

const rootReducer = (state = initialState, action) => {
  switch(action.type) {
    case UPDATE_CHAPTER:
      return {
        ...state,
        currentChapter: action.payload.title,
      };
    case UPDATE_SCENARIO:
      return {
        ...state,
        scenarios: {
          ...state.scenarios,
          [action.payload.id]: action.payload,
        }
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export default createStore(rootReducer, composeWithDevTools());



// WEBPACK FOOTER //
// ./src/services/store.js